import { useApiCall, UseApiCallOptions } from "./hooks/useApiCall";

export const makeUseApiCall =
  <ApiCallFnT extends (...args: any) => Promise<any>>(apiCallFn: ApiCallFnT) =>
  (options: UseApiCallOptions<ReturnType<ApiCallFnT> | null> = {}) => {
    return useApiCall(apiCallFn, options);
  };
